import { DataHeader, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutManualOpenItem extends Layout {
    dataheaderManualOpenItem: DataHeader;
    sourceOpenItemManual: DataSource;
    textboxAmount: Textbox;
    textboxBillDate: Textbox;
    textboxCurrencyType: Textbox;
    textboxCustomerId: Textbox;
    textboxDepositNumber: Textbox;
    textboxGlDate: Textbox;
    textboxInvoiceNumber: Textbox;
    textboxOrderId: Textbox;
    textboxRecordType: Textbox;
    textboxReferenceNumber: Textbox;
    textboxRemark: Textbox;
    textboxShipDate: Textbox;
}
